import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const otherAutoImmuneSystemDisorder: AnswerPathTreeNode = {
  path: 'otherAutoImmuneSystemDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredOtherAutoImmuneSystemDisorderDetails }],
};
